import {Navigate, useLocation, useParams} from 'react-router';
import {HUB, legacyRoomTarget, legacySummaryTarget, reservationIdOf} from '../consultation/deepLinks';
import ConsultationRoom from './ConsultationRoom';

/** Legacy email link: /virtual-consultation/room?reservation_id=<id> (replaces the history entry). */
export function LegacyRoomRedirect() {
  const {search} = useLocation();
  return <Navigate to={legacyRoomTarget(search)} replace />;
}

/** Legacy email link: /virtual-consultation/summary?reservation_id=<id>. */
export function LegacySummaryRedirect() {
  const {search} = useLocation();
  return <Navigate to={legacySummaryTarget(search)} replace />;
}

/** The video room for a valid id; any other id goes to the hub instead of a broken room. */
export function RoomRoute() {
  const {reservationId} = useParams();
  if (!reservationIdOf(reservationId)) return <Navigate to={HUB} replace />;
  return <ConsultationRoom />;
}
